import React from 'react';
import './alerts-styles.css'

function Alerts({children, color}) {
    return (
        <div className={`alerts ${color}`}>
            {children}
        </div>
    );
}

export default Alerts;